import { render } from "./ChangeDueDate.vue?vue&type=template&id=50cb2f1b&scoped=true"
import script from "./ChangeDueDate.vue?vue&type=script&lang=js"
export * from "./ChangeDueDate.vue?vue&type=script&lang=js"

import "./ChangeDueDate.vue?vue&type=style&index=0&id=50cb2f1b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50cb2f1b"]])

export default __exports__